export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const SET_NOTIFICATION_BANNER = "SET_NOTIFICATION_BANNER";
export const SET_NOTIFICATION_USER_READS = "SET_NOTIFICATION_USER_READS";
export const ADD_NOTIFICATION_USER_READ = "ADD_NOTIFICATION_USER_READ";
